import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, } from "./data-psm-executor-utils.js";
export async function executeDataPsmSetRoots(reader, createNewIdentifier, operation) {
    const resource = await loadDataPsmSchema(reader);
    if (resource === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            dataPsmRoots: [...operation.dataPsmRoots],
        },
    ]);
}
//# sourceMappingURL=data-psm-set-roots-executor.js.map